import $ from "jquery";
import * as Common from "../../../../common/common";
import * as omnimap from "../../../../../api/omnimap/omnimapActions";
import * as GC from "../../../../common/common";

export default function standart() {}

export const FillTableCallBack = (result, page_number, columnList) => {
  var oTable = $("#example").dataTable();
  if (page_number === 1) {
    oTable.fnClearTable();
  }
  if (page_number <= result.meta.total_pages) {
    if (result.data.length > 0) {
      $.each(result.data, function (index, data) {
        var circleType = `<div class="green-circle rounded-circle"><span class="tooltiptext">Actief</span></div>`;
        var checkbox =
          '<label class="ct-checkbox"><input type="checkbox"><span class="checkmark"></span></label>';

        var identification = data["identification"];
        /**diğer alanların başlangıcı */
        var algemeenGisratio = data.content["algemeen-gisratio"];
        if (typeof algemeenGisratio === "undefined") {
          algemeenGisratio = "";
        }
        var status = data.status[0].status;
        if (typeof status === "undefined") {
          status = "";
        }
        var maatregelNaam = data.content["maatregel-naam"];
        if (typeof maatregelNaam === "undefined") {
          maatregelNaam = "";
        }
        var beheeractiviteitLaag = data.content["beheeractiviteit-laag"];
        if (typeof beheeractiviteitLaag === "undefined") {
          beheeractiviteitLaag = "";
        }
        var beheereenheidNaam = data.content["beheereenheid-naam"];
        if (typeof beheereenheidNaam === "undefined") {
          beheereenheidNaam = "";
        }
        var disciplineNaam = data.content["discipline-naam"];
        if (typeof disciplineNaam === "undefined") {
          disciplineNaam = "";
        }
        var statusTijdstipVerzonden = data.content["status-tijdstip_verzonden"];
        if (typeof statusTijdstipVerzonden === "undefined") {
          statusTijdstipVerzonden = "";
        } else statusTijdstipVerzonden = GC.FormatDate(statusTijdstipVerzonden, "date");

        var timestampCreated = data["timestamp_created"];
        if (typeof timestampCreated === "undefined") {
          timestampCreated = "";
        } else timestampCreated = GC.FormatDate(timestampCreated, "date");

        var timestampUpdated = data["timestamp_updated"];
        if (typeof timestampUpdated === "undefined") {
          timestampUpdated = "";
        } else timestampUpdated = GC.FormatDate(timestampUpdated, "date");

        var model = {
          identification: identification,
          algemeenGisratio: algemeenGisratio,
          status: status,
          maatregelNaam: maatregelNaam,
          beheereenheidNaam: beheereenheidNaam,
          beheeractiviteitLaag: beheeractiviteitLaag,
          disciplineNaam: disciplineNaam,
          statusTijdstipVerzonden: statusTijdstipVerzonden,
          timestampCreated: timestampCreated,
          timestampUpdated: timestampUpdated,
        };
        window.$mm_work_order_Glist.push(model);

        var test = {
          checkbox: checkbox,
          active: circleType,
          "Gisratio Id": algemeenGisratio,
          Status: status,
          "Naam maatregel": maatregelNaam,
          Laag: beheeractiviteitLaag,
          "Naam beheereenheid": beheereenheidNaam,
          "Naam discipline": disciplineNaam,
          "Tijdstip verzonden": statusTijdstipVerzonden,
          "Datum aangemaakt": timestampCreated,
          "Datum laatst gewijzigd": timestampUpdated,
        };

        var _columnList = [];
        for (let column in columnList.column_list) {
          for (let key in test) {
            if (
              columnList.column_list[column].toLowerCase() == key.toLowerCase()
            ) {
              _columnList.push(test[key]);
            }
          }
        }

        var addId = oTable.fnAddData(
          [
            ..._columnList,
            // checkbox,
            // circleType,
            // algemeenGisratio,
            // status,
            // maatregelNaam,
            // beheeractiviteitLaag,
            // beheereenheidNaam,
            // disciplineNaam,
            // statusTijdstipVerzonden,
            // timestampCreated,
            // timestampUpdated,
          ],
          false
        );

        var theNode = $("#example").dataTable().fnSettings().aoData[
          addId[0]
        ].nTr;
        theNode.setAttribute("rowId", data["identification"]);
      });
      oTable.fnDraw();
    } else {
      $("tbody").html();
      oTable.fnClearTable();
    }
  }

  $("#total-rows").html(result.meta.total_found);
  window.$mm_work_order_table_total_row_count = result.meta.total_found;
  $("#cover-spin").hide(0);
  window.$mm_work_order_treeChangeStatus = true;
  window.$mm_work_order_gvv = 0;
  window.$mm_work_order_scroll_change = true;
};

export const FillFilterColumnsCallBack = (data, result) => {
  if (data.id === "algemeen-gisratio") {
    $.each(result.data.values, function (index, data) {
      window.$mm_work_order_plannigAlgemeenGisratio.push(data);
    });
  } else if (data.id === "status") {
    $.each(result.data.values, function (index, data) {
      window.$mm_work_order_plannigStatus.push(data);
    });
  } else if (data.id === "maatregel-naam") {
    $.each(result.data.values, function (index, data) {
      window.$mm_work_order_maatregelNaam.push(data);
    });
  } else if (data.id === "werkplan-naam") {
    $.each(result.data.values, function (index, data) {
      window.$mm_work_order_werkplanNaam.push(data);
    });
  } else if (data.id === "beheereenheid-naam") {
    $.each(result.data.values, function (index, data) {
      window.$mm_work_order_beheereenheidNaam.push(data);
    });
  } else if (data.id === "beheeractiviteit-laag") {
    $.each(result.data.values, function (index, data) {
      window.$mm_work_order_beheeractiviteitLaag.push(data);
    });
  } else if (data.id === "discipline-naam") {
    $.each(result.data.values, function (index, data) {
      window.$mm_work_order_disciplineNaam.push(data);
    });
  } else if (data.id === "status-tijdstip_verzonden") {
    $.each(result.data.values, function (index, data) {
      window.$mm_work_order_statusTijdstipVerzonden.push(data);
    });
  }
};

export const SearchFilterColumnsCallBack = (searchId, result) => {
  if (searchId === "algemeen-gisratio") {
    window.$mm_work_order_plannigAlgemeenGisratio.length = 0;
    $.each(result.data.values, function (index, data) {
      window.$mm_work_order_plannigAlgemeenGisratio.push(data);
    });
  } else if (searchId === "status") {
    window.$mm_work_order_plannigStatus.length = 0;
    $.each(result.data.values, function (index, data) {
      window.$mm_work_order_plannigStatus.push(data);
    });
  } else if (searchId === "maatregel-naam") {
    window.$mm_work_order_maatregelNaam.length = 0;
    $.each(result.data.values, function (index, data) {
      window.$mm_work_order_maatregelNaam.push(data);
    });
  } else if (searchId === "beheereenheid-naam") {
    window.$mm_work_order_beheereenheidNaam.length = 0;
    $.each(result.data.values, function (index, data) {
      window.$mm_work_order_beheereenheidNaam.push(data);
    });
  } else if (searchId === "beheeractiviteit-laag") {
    window.$mm_work_order_beheeractiviteitLaag.length = 0;
    $.each(result.data.values, function (index, data) {
      window.$mm_work_order_beheeractiviteitLaag.push(data);
    });
  } else if (searchId === "discipline-naam") {
    window.$mm_work_order_disciplineNaam.length = 0;
    $.each(result.data.values, function (index, data) {
      window.$mm_work_order_disciplineNaam.push(data);
    });
  } else if (searchId === "status-tijdstip_verzonden") {
    window.$mm_work_order_statusTijdstipVerzonden.length = 0;
    $.each(result.data.values, function (index, data) {
      window.$mm_work_order_statusTijdstipVerzonden.push(data);
    });
  }
};

export const GetActionsOfRowCallback = (result) => {
  var actionsOfSelection = [];
  var actionsOfDisabled = [];

  $.each(result.data.stages, function (index, stage) {
    if (stage.definition.type === "activity" && stage.start_allowed === true) {
      actionsOfSelection.push(stage.definition.identification);
    } else {
      actionsOfDisabled.push(stage.definition);
    }
  });

  $("#myPopup").html("");
  $.each(window.$mm_work_order_actions, function (index, action) {
    if ($.inArray(action["id"], actionsOfSelection) !== -1) {
      var anchor = $("<a></a>")
        .attr({ href: "javascript:void(0)", id: action["id"] })
        .addClass(action["class"] + " mm_workorder_action")
        .html(action["text"]);
      $("#myPopup").append(anchor);
    }
  });
  //** aktif olmayan actionlar burada listeleniyor. */
  $.each(actionsOfDisabled, function (index, action) {
    var anchor = $("<a disabled></a>")
      .attr({ href: "javascript:void(0)", id: action["identification"] })
      .addClass("disabled" + " catalog-action")
      .html(action["name"]);
    $("#myPopup").append(anchor);
  });
  const showOnMap = $("<a></a>")
      .attr({ role: "button", id: "wo_toon_dossiers_op_kaart" })
      .addClass("locate action")
      .html("Toon op kaart");
  $("#myPopup").append(showOnMap);

  var popup = document.getElementById("myPopup");
  popup.classList.toggle("show");
};

export function TableColumnChangeHandler(
  settings,
  data,
  identification,
  columnOrderReference,
  COLUMN_ORDER_CATALOG_MANAGEMENT_UNIT
) {
  var names = settings.aoColumns;
  if (names[0]) {
  }
  var test_list = [];
  names.forEach((element, index) => {
    test_list.push(element.sTitle);
  });

  var checkIndex = test_list.findIndex((x) => x.includes("checkAll"));
  test_list[checkIndex] = "checkbox";
  var statusIndex = test_list.findIndex((x) => x.includes("snowflake"));
  test_list[statusIndex] = "active";
  var model = {
    identification: identification,
    code: COLUMN_ORDER_CATALOG_MANAGEMENT_UNIT,
    client_identification: COLUMN_ORDER_CATALOG_MANAGEMENT_UNIT,
    reference: columnOrderReference,
    data: {
      table_sorting: [
        {
          name: "management-maintenance>workorder",
          column_list: [],
        },
      ],
    },
  };
  var asd = (model.data.table_sorting.find(
    (x) => x.name === "management-maintenance>workorder"
  ).column_list = test_list);
  omnimap.GetFreeFormatAction(identification, "PUT", model);

  return model.data.table_sorting[0];
}
